<template>
    <div>
        <room-form 
          :is-room-form-sidebar-active.sync="isRoomFormSidebarActive"
          :room-data="roomData"
          @refetch-data="refetchData"
        />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    ></b-col>
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            />
                            <b-button
                                variant="primary"
                                @click="updateRoom()"
                            >
                                <span class="text-nowrap">Add Room</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table
                v-if="!rooms.length"
                :items="rooms"
                responsive
                :fields="tableColumns"
                show-empty
                empty-text="No matching records found"
                class="position-relative"
            >
            </b-table>
            <table v-else class="table table-striped">
                <thead>
                    <tr>
                    <th scope="col" v-for="(col, index) in tableColumns" :key="index">
                        {{col.label}}
                    </th>
                    </tr>
                </thead>
                <draggable v-model="rooms" tag="tbody" hadle=".handle" @change="updateRoomsOrdering()">
                    <tr v-for="(item, index) in rooms" :key="index">
                        <th scope="row" class="pl-2">
                            <MenuIcon icon="MenuIcon"/> 
                        </th>
                        <td class="pl-2">
                            <b-img
                            :src="getCoverImage(item.files)"
                            height="110"
                            width="170"
                            class="rounded m-0"
                            />
                        </td>
                        <td class="pl-2">
                            <span>{{ item.title[currentLocale] }}</span>
                        </td>
                        <td class="pl-2">
                            <span v-html="(item.slug[currentLocale])"></span>
                        </td>
                        <td class="pl-2">
                            <b-badge
                                pill
                                :variant="`light-${resolveRoomStatusVariant(item.is_active)}`"
                                class="text-capitalize"
                            >
                                {{ resolveRoomStatusnameVariant(item.is_active) }} 
                            </b-badge>
                        </td>
                        <td class="pl-2">
                            <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateRoom(item)" variant="outline-success">Edit</b-button>
                            <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(item.id)" variant="outline-danger">Delete</b-button>
                        </td>
                    </tr>
                </draggable>
            </table>
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRooms"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                                </template>
                                <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
    </template>
    
    <script>
    import {
      BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BImg,
      BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox,BImgLazy
    } from 'bootstrap-vue';
    import store from "@/store";
    import Ripple from 'vue-ripple-directive';
    import { ref,onUnmounted } from '@vue/composition-api';
    import vSelect from 'vue-select';
    import draggable from 'vuedraggable';
    import { MenuIcon } from 'vue-feather-icons';
    import roomStoreModule from '../roomStoreModule';
    import useRoomList from '../room-list/useRoomList';
    import RoomForm from '../room-form/RoomForm.vue'
    
    export default {
        components:{
            BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
            BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox, 
            BImg, BImgLazy, draggable, MenuIcon, vSelect, RoomForm
        },
    
        directives:{
            'b-modal': VBModal,
            Ripple
        },
    
        computed: {
           currentLocale() {
             return  this.$i18n.locale;
           },
        },
    
        setup(){
            const STORE_MODULE_NAME = 'app-room';
            if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, roomStoreModule)
            onUnmounted(() => {
                if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
            });
    
            const getCoverImage = (files) => {
                if(files.length){
                    for(const file of files){
                        if(file.is_feature){
                            return file.path
                        }
                    }
                } else {
                    return `${require('@/assets/images/no-image.png')}`
                }
            }
    
            const {
                roomData,
                tableColumns,
                refRoomListTable,
                perPage,
                totalRooms,
                searchQuery,
                dataMeta,
                fetchData,
                resolveRoomStatusnameVariant,
                resolveRoomStatusVariant,
                rooms,
                currentPage,
                statusFilter,
                refetchData,
                updateRoom,
                isRoomFormSidebarActive,
                deleteData,
                coverImage,
                totalCategories,
                updateRoomsOrdering,
            } = useRoomList();
    
            fetchData()
    
            return {
                roomData,
                tableColumns,
                refRoomListTable,
                perPage,
                totalRooms,
                searchQuery,
                dataMeta,
                fetchData,
                resolveRoomStatusnameVariant,
                resolveRoomStatusVariant,
                rooms,
                currentPage,
                statusFilter,
                refetchData,
                updateRoom,
                isRoomFormSidebarActive,
                deleteData,
                coverImage,
                totalCategories,
                updateRoomsOrdering,
                getCoverImage,
            }
        },
        
        methods:{
            deleteconfirm(id){
                this.$bvModal
                    .msgBoxConfirm(`Please confirm that you want to delete Food Category ID = ${id}`, {
                        title: 'Please Confirm',
                        size: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        cancelVariant: 'outline-secondary',
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then(value => {
                        if(value === true){
                        this.deleteData(id)
                    }
                })
            },
        }
    }
    </script>